import { render, staticRenderFns } from "./InvoicePaymentDialog.vue?vue&type=template&id=12ff4d2a&scoped=true"
import script from "./InvoicePaymentDialog.vue?vue&type=script&lang=js"
export * from "./InvoicePaymentDialog.vue?vue&type=script&lang=js"
import style0 from "./InvoicePaymentDialog.vue?vue&type=style&index=0&id=12ff4d2a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ff4d2a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12ff4d2a')) {
      api.createRecord('12ff4d2a', component.options)
    } else {
      api.reload('12ff4d2a', component.options)
    }
    module.hot.accept("./InvoicePaymentDialog.vue?vue&type=template&id=12ff4d2a&scoped=true", function () {
      api.rerender('12ff4d2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tutition_v3/dialog/InvoicePaymentDialog.vue"
export default component.exports